import React from "react";
import { useParams, Navigate, Outlet } from "react-router-dom";

const allowedLanguages = ["hy", "ru", "en"];

function LanguageValidator() {
    const { lng } = useParams();

    if (!allowedLanguages.includes(lng)) {
        return <Navigate to="/404" replace />;
    }

    return <Outlet />;
}

export default LanguageValidator;
